import { render, staticRenderFns } from "./ManterPeticaoExibir.vue?vue&type=template&id=81c3ee68&scoped=true&"
import script from "./ManterPeticaoExibir.vue?vue&type=script&lang=js&"
export * from "./ManterPeticaoExibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c3ee68",
  null
  
)

export default component.exports